import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];
  static values = {
    uuid: String,
    index: Number,
    type: String,
  };

  connect() {}

  addMapping(event) {
    event.preventDefault();
    let index = this.containerTarget.children.length;

    fetch(
      `/user_integrations/${this.uuidValue}/add_mapping?index=${index}&type=${this.typeValue}`,
      {
        method: "GET",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
          Accept: "text/vnd.turbo-stream.html",
        },
      },
    )
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html));
  }

  removeMapping(event) {
    event.preventDefault();

    let index = this.indexValue;

    fetch(
      `/user_integrations/${this.uuidValue}/remove_mapping?index=${index}&type=${this.typeValue}`,
      {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
          Accept: "text/vnd.turbo-stream.html",
        },
      },
    )
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html));
  }
}
